import type { InseeFullDemographics } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export interface DocumentItem {
  url: string
  name: string
  size: number
  uploadedAt: string
}

export interface StoreProjectResponse {
  id: string
  name: string
  address: string
  city: string
  postalCode: string
  surfaceArea: number
  score: number
  status: 'before_project' | 'under_study' | 'secured' | 'works' | 'open'
  rentPerYear: number
  works: number
  leaseFunds: number
  contacts: {
    id: string
    name: string
    email: string
    phone: string
  }[]
  googleMapsUrl: string | null
  photoUrls: string[]
  documents: DocumentItem[]
  comment: string
  createdAt: string
  updatedAt: string
  demographics: InseeFullDemographics | null
}

// Fetch all store projects
export const fetchStoreProjects = async () => {
  const response = await gozokiApiWithAuth.get<StoreProjectResponse[]>('/store-projects')
  return response.data
}
